import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './GatingMessage.scss';
import Tooltip from '../Tooltip/Tooltip';
import Icon from '../Icon';
import InfoIcon from '../../svg/icons/ic_info-outline_20x20.svg';
import CloseIcon from '../../svg/icons/ic_close_circle_20x20.svg';
import { getTranslation } from '../../providers/TranslationProvider';

const GatingToolTip = (props) => {
  const { animation, eventData, Analytics } = props;
  const [visible, setVisible] = useState(false);
  const [hover, setHover] = useState(false);

  /* eslint-disable-next-line max-len */
  const toolTipCopy = 'Eligible American Express® Cards include The Platinum Card® from American Express Exclusively for Charles Schwab, Centurion® Card from American Express, Delta SkyMiles® Reserve American Express Card, Hilton Honors American Express Aspire Card, The Centurion® Card from American Express for Goldman Sachs, The Platinum Card®, The Platinum Card® from American Express Exclusively for Morgan Stanley, The Platinum Card® from American Express for Goldman Sachs, Business Centurion, Business Platinum Card®, Delta SkyMiles® Reserve Business American Express Card, Corporate Centurion Card and Corporate Platinum Card®.';

  return (
    <Tooltip
      theme="dark"
      content={getTranslation({ translationKey: 'gating_tooltip_content', fallback: toolTipCopy })}
      trigger="mouseenter focus"
      arrow="round"
      visible={visible || hover}
      zIndex={10}
      animation={animation}
      onClickOutside={() => {
        setVisible(false);
        setHover(false);
      }}
    >
      <Button
        variant="no-style"
        onClick={() => {
          if (visible) {
            setHover(false);
          } else {
            Analytics.event('interact with gating modal', eventData);
          }
          setVisible(!visible);
        }}
        data-testid="gating_error_tool_tip_btn"
        className="GatingToolTip__button"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        aria-label={visible ? getTranslation({ translationKey: 'hide_tool_tip', fallback: 'Hide Tooltip' }) : getTranslation({ translationKey: 'show_tool_tip', fallback: 'Show Tooltip' })}
      >
        {visible && (
        <Icon
          className="GatingToolTip__Icon"
          name="show"
          component={CloseIcon}
          height="20px"
          width="20px"
        />
        )}
        {!visible && (
        <span>
          <Icon
            className="GatingToolTip__Icon"
            name="hide"
            component={InfoIcon}
            height="20px"
            width="20px"
          />
        </span>
        )}
      </Button>
    </Tooltip>
  );
};

GatingToolTip.propTypes = {
  animation: PropTypes.bool,
  eventData: PropTypes.shape({
    venue: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    platform: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    eventAsset: PropTypes.string.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

GatingToolTip.defaultProps = {
  animation: true,
};

export default GatingToolTip;
